import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TranslateTextApi, TranslateTextRequest, TranslateTextResponse } from '../../translate-text-api';

/**
 * TranslateTextApi 的 Mock 实现
 * 用于前端开发，在后端接口未完成时使用
 */
@injectable()
export class TranslateTextApiMock implements TranslateTextApi {
    /**
     * Mock 翻译文本
     * 返回模拟的翻译结果
     */
    async translateText(data: TranslateTextRequest): Promise<TranslateTextResponse> {
        // 模拟 API 延迟
        await new Promise(resolve => setTimeout(resolve, 500));

        // 简单的 mock 翻译逻辑
        const mockTranslations: Record<string, string> = {
            // 韩语示例
            '이것은 테스트입니다': '这是一个测试',
            '특허 출원': '专利申请',

            // 日语示例
            'これはテストです': '这是一个测试',
            '特許出願': '专利申请',

            // 法语示例
            'Ceci est un test': '这是一个测试',
            'demande de brevet': '专利申请',

            // 德语示例
            'Dies ist ein Test': '这是一个测试',
            'Patentanmeldung': '专利申请',
        };

        // 如果有预定义的翻译，返回预定义的
        if (mockTranslations[data.text]) {
            return {
                text: mockTranslations[data.text],
            };
        }

        // 否则返回带前缀的原文（表示这是 mock 翻译）
        return {
            text: `[Mock翻译: ${data.from}→${data.to}] ${data.text}`,
        };
    }
}
